package io.horion.cv.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.CountryCard
import io.horion.cv.styles.BlueGradientTextStyle
import io.horion.cv.styles.CountryButtonStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.UBUNTU
import io.horion.cv.models.CountryData
import io.horion.cv.styles.ArrowImageStyle
import io.horion.cv.styles.ArrowWhiteImageStyle
import io.horion.cv.styles.ArrowWrapperStyle
import io.horion.cv.styles.CountryButtonArrowStyle
import io.horion.cv.styles.CountryButtonLabelLongStyle
import io.horion.cv.styles.CountryButtonLabelShortStyle
import io.horion.cv.styles.CountryCardsRowStyle
import io.horion.cv.styles.CountryDescriptionTextStyle
import io.horion.cv.styles.CountryDescriptionsubTextStyle
import io.horion.cv.styles.CountrySectionContainerStyle
import io.horion.cv.styles.CountryTitleDesktopStyle
import io.horion.cv.styles.CountryTitleDesktopTextStyle
import io.horion.cv.styles.CountryTitleMobileStyle
import io.horion.cv.styles.CountryTitleMobileTextStyle
import io.horion.cv.styles.ViewMoreButtonStylecss
import io.horion.cv.utils.Constants.POPPINS
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
fun CountrySection() {
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val sectionBg = if (isDark) Colors.holder else Colors.LighterBlue.copy(alpha = 20)
    val descTextColor = if (isDark) Colors.LightBlue else Colors.DarkBlue

    Column(
        modifier = CountrySectionContainerStyle.toModifier()
            .backgroundColor(sectionBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .fillMaxWidth(),
//            .padding(top = 30.px, bottom = 40.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Column(
            modifier = CountryTitleMobileStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                "Postulez au Cameroun\nou à l'étranger",
                modifier = BlueGradientTextStyle.toModifier()
                    .then(CountryTitleMobileTextStyle.toModifier())
                    .fontFamily(POPPINS)
                    .fontWeight(FontWeight.Bold)
                    .whiteSpace(WhiteSpace.PreWrap)
                    .textAlign(TextAlign.Center)
            )
        }

        // En-tête Titre Desktop
        Row(
            modifier = CountryTitleDesktopStyle.toModifier(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                "Postulez au Cameroun ou à l'étranger",
                modifier = BlueGradientTextStyle.toModifier()
                    .then(CountryTitleDesktopTextStyle.toModifier())
                    .fontFamily(POPPINS)
                    .fontWeight(FontWeight.Bold)
            )
        }

        SpanText(
            "CV vous aide dans votre demarche en proposant des cv adaptés à chaque pays.",
            modifier = CountryDescriptionTextStyle.toModifier()
//                .fontSize(if (isMobile) 15.px else 20.px)
                .fontFamily(POPPINS)
                .color(descTextColor)
                .textAlign(TextAlign.Center)
//                .padding(leftRight = if (isMobile) 15.px else 0.px)
        )
        SpanText(
            "Où que vous soyez, nous souhaitons jouer un rôle dans l'obtention de votre emploi.",
            modifier = CountryDescriptionsubTextStyle.toModifier()
//                .fontSize(if (isMobile) 15.px else 20.px)
                .fontFamily(POPPINS)
                .color(descTextColor)
                .textAlign(TextAlign.Center)
//                .padding(leftRight = if (isMobile) 15.px else 0.px)
//                .margin(bottom = if (isMobile) 10.px else 0.px)
        )
        Row(modifier = CountryCardsRowStyle.toModifier()
            .fillMaxWidth()
            .maxWidth(1200.px)
//            .margin(bottom = if (isMobile) 10.px else 20.px)
//            .gap(if (isMobile) 10.px else 80.px)
//            .justifyContent(JustifyContent.Center),
        ) {
            CountryData.countries.forEach { country ->
                CountryCard(
                    country = country
                )

            }
        }
        CustButton(
            onClick = { ctx.router.navigateTo("/creer_un_cv") }
        )
    }
}

@Composable
fun CustButton(
    onClick: (SyntheticMouseEvent) -> Unit,
) {

    Button(
        onClick = onClick,
        modifier = CountryButtonStyle.toModifier()
            .then(ViewMoreButtonStylecss.toModifier())
            .borderRadius(40.px)
            .fontWeight(FontWeight.Normal)
            .fontFamily(UBUNTU)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("gap", "10px")
            }
    ) {
        SpanText("CV par pays", modifier = CountryButtonLabelShortStyle.toModifier())
        SpanText("Les CV par pays", modifier = CountryButtonLabelLongStyle.toModifier())

        Box(
            modifier = ArrowWrapperStyle.toModifier(),
            contentAlignment = Alignment.Center
        ) {
            FaArrowRight(modifier = ArrowImageStyle.toModifier())
        }
    }
}